import { Grid } from "@material-ui/core";
import MaterialTable from "material-table";
import React from "react";
import { useStylesContainers } from "../../../../St/comps/UseStyle";
import { cellS, headerS } from "../groups/groups-style";

const CostCentersTable = (props) => {
  const { data, onShow } = props;
  const clsConts = useStylesContainers();
  var columns = [
    { title: "رقم المركز", field: "id" },
    { title: "اسم المركز  ", field: "Name" },
  ];

  function onRowClickHandle(data) {
    onShow({ ...data }, "edit");
  }
  return (
    <Grid item container lg={12} md={12} className={[clsConts.rootdown]}>
      <Grid
        item
        container
        xs={12}
        className={[clsConts.subDown, clsConts.subDownC]}
      >
        <Grid item xs={12}>
          <MaterialTable
            style={{ boxShadow: "none" }}
            title=""
            // variant="outlined"
            options={{
              pageSize: 7,
              //showTitle:false,
              toolbar: false,
              sorting: false,
              showTitle: false,
              paging: false,

              headerStyle: headerS,
              cellStyle: cellS,
              maxBodyHeight: "65vh",
              minBodyHeight: "65vh",
            }}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h3
                    style={{
                      marginTop: "20vh",
                      border: "solid 0px",
                      boxShadow: "none",
                    }}
                  ></h3>
                ),
              },
            }}
            columns={columns}
            data={data}
            onRowClick={(event, rowData) => {
              onRowClickHandle(rowData);
              event.stopPropagation();
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CostCentersTable;
